import { 
	ACCOUNTS,
    CARDS,
    LOANSANDMORTGAGES,
    DEPOSITS,
    INVESTMENTS
} from 'constants/aggregator/products'; 


function isAggregatorProductEnabled(featureToggleReducer, product) {
	const mapByProduct = {
		[ACCOUNTS]: "agregador-accounts-enabled",
		[CARDS]: "agregador-cards-enabled",
		[DEPOSITS]: "agregador-deposits-enabled",
		[INVESTMENTS]: "agregador-investments-enabled",
		[LOANSANDMORTGAGES]: "agregador-loans-enabled"
	}
	return featureToggleReducer.get(mapByProduct[product])
}

function isAggregatorEnabled(featureToggleReducer) {
	const mapByProduct = {
		[ACCOUNTS]: "agregador-accounts-enabled",
		[CARDS]: "agregador-cards-enabled",
		[DEPOSITS]: "agregador-deposits-enabled",
		[INVESTMENTS]: "agregador-investments-enabled",
		[LOANSANDMORTGAGES]: "agregador-loans-enabled"
	}
	return [ACCOUNTS, CARDS, DEPOSITS, INVESTMENTS, LOANSANDMORTGAGES].some(p => featureToggleReducer.get(mapByProduct[p]))
}

module.exports = {
	isAggregatorProductEnabled,
	isAggregatorEnabled
}